import React, { FC, ReactNode } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} `}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="flex-grow">
          <img className="w-full" src={rightImg} alt="" />
        </div>
        <div className="w-screen max-w-full  space-y-5 lg:space-y-7">
          <span className="text-[#EDAB17]">About Us</span>
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            {heading}
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            Jonathan and Karen are Bay Area residents who have spent over two
            decades working in the tech industry. As their three teenagers
            neared adulthood, they sought a new venture they could build
            together. Their passion for luxury cars, once a hobby, evolved into
            the idea for JoyRides: a luxury car rental company founded on the
            belief that every trip should be a joyful experience.
            <br />
            <br />
            Joyrides is a locally-owned and operated company that provides an
            alternative to major car rental companies. The goal for every rental
            is to make sure the experience is top-notch. Whether you’re renting
            an SUV for a weekend snow trip, a convertible for a sunny coastal
            drive, or a sports car for a business trip, Joyrides has the perfect
            vehicle for you!
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
